import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=06413d34&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=06413d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06413d34",
  null
  
)

export default component.exports